import { useTranslation } from "next-i18next";
import React from "react";
import { Container, Row } from "react-bootstrap";
import IconAndTextItem, {
  IconAndTextItemType,
} from "../utilities/Navigation/IconAndTextItem/IconAndTextItem";
import RocketSVG from "../../public/icons/benefits/rocket.svg";
import StarsSVG from "../../public/icons/benefits/stars.svg";
import CPUSVG from "../../public/icons/benefits/cpu.svg";
import BulbSVG from "../../public/icons/benefits/bulb.svg";
import PresentSVG from "../../public/icons/benefits/present.svg";
import TshirtSVG from "../../public/icons/benefits/tshirt.svg";

const Benefits = () => {
  const { t } = useTranslation("career");

  const items: IconAndTextItemType[] = [
    {
      icon: <RocketSVG />,
      title: t("benefits.first_item.title"),
    },
    {
      icon: <StarsSVG />,
      title: t("benefits.second_item.title"),
    },
    {
      icon: <CPUSVG />,
      title: t("benefits.third_item.title"),
    },
    {
      icon: <BulbSVG />,
      title: t("benefits.fourth_item.title"),
    },
    {
      icon: <PresentSVG />,
      title: t("benefits.fifth_item.title"),
    },
    {
      icon: <TshirtSVG />,
      title: t("benefits.sixth_item.title"),
    },
  ];

  return (
    <Container className="container-inner-spacing max-content-width text-center">
      <h2 className="mb-6 mb-md-8">{t("benefits.title")}</h2>
      <Row>
        {items.map((item, index) => (
          <IconAndTextItem md={4} key={`benefits-item-${index}`} data={item} />
        ))}
      </Row>
    </Container>
  );
};

export default Benefits;
